/**
 * FreeSpinsIntroOutroView
 *
 * Handles the view functionality of the free spins dialog(s)
 */
(function () {
  class FreeSpinsIntroOutro extends PIXI.Container {
    constructor() {
      super();

      this._callback = undefined;

      this.visible = false;

      this._spinsWon = undefined;
      this._outroPanel = undefined;
      this._cashWon = undefined;

      this._upgradeContainers = [];

      this._pressStartBox = undefined;
      this._introActive = false;
    }

    initialise() {
      const self = this;

      messageBus.subscribe("spinner:GameConfigEvent", function () {
        self.onLayoutComplete();
      });
    }

    onLayoutComplete() {
      this._gambleBacker = resourceManager.get("gambleBacker");
      this._fullPanel = resourceManager.get("freeSpinsIntroOutroContainer:FreeSpinsIntroOutro");

      this._spinsWon = resourceManager.get(
        "freeSpinsIntroOutroContainer:FreeSpinsIntroOutro:introPanel:numFreeSpinsText"
      );

      this._introPanel = resourceManager.get("freeSpinsIntroOutroContainer:FreeSpinsIntroOutro:introPanel");
      this._introPanel.visible = false;

      this._outroPanel = resourceManager.get("freeSpinsIntroOutroContainer:FreeSpinsIntroOutro:outroPanel");
      this._outroPanel.visible = false;

      this._cashWon = resourceManager.get("freeSpinsIntroOutroContainer:FreeSpinsIntroOutro:outroPanel:cashWonText");
      this._cashWon.visible = false;

      this._pressStartBox = resourceManager.get("freeSpinsIntroOutroContainer:FreeSpinsIntroOutro:pressStartColourBox");

      this._pressStartBox.alpha = 0;
      this._pressStartBox.visible = false;
      this._pressStartBox.interactive = false;

      const continueText1 = resourceManager.get("freeSpinsIntroOutroContainer:FreeSpinsIntroOutro:introPanel:continueContainer");

      gsap.to(continueText1, {
        duration: 0.8,
        pixi: { scaleX: 0.92, scaleY: 0.92 },
        yoyo: true,
        repeat: -1,
        ease: "power1.inOut",
      });

      const continueText2 = resourceManager.get("freeSpinsIntroOutroContainer:FreeSpinsIntroOutro:outroPanel:continueContainer");

      gsap.to(continueText2, {
        duration: 0.8,
        pixi: { scaleX: 0.92, scaleY: 0.92 },
        yoyo: true,
        repeat: -1,
        ease: "power1.inOut",
      });

      const burst1 = resourceManager.get("freeSpinsIntroOutroContainer:FreeSpinsIntroOutro:introPanel:burst");
      const burst2 = resourceManager.get("freeSpinsIntroOutroContainer:FreeSpinsIntroOutro:outroPanel:burst");

      gsap.to([burst1, burst2], {
        duration: 5,
        rotation: -Math.PI * 2,
        repeat: -1,
        ease: "none",
      });
    }

    setup() {
      this._pressStartBox.visible = true;
      this._pressStartBox.alpha = 0;
    }

    async showIntro(numFS, callback) {
      musicManager.onFreeSpinsIntro();
      resourceManager.getContainer("gambleIntroContainer").visible = true;

      gameController.canSlamStop = false;

      this._introActive = true;
      this.setup();

      this._callback = callback;
      this._outroPanel.visible = false;
      this._introPanel.visible = true;
      this._cashWon.visible = false;

      this._spinsWon.text = numFS;

      // gameController.fullScreenBubblesFront.startBubbles();
      // timerManager.addTimeout(500, function () {
      //   gameController.fullScreenBubblesFront.stopBubbles();
      // });
      // gameController.fullScreenBubblesBack.startBubbles();

      this.fadeIn(this._gambleBacker, 0.8, 1.0, 0.0);

      this.scaleInPanel(true);

      let self = this;
      timerManager.addTimeout(1000, function () {
        self.setActive();
      });
    }

    scaleInPanel(isIntro) {
      this._fullPanel.visible = true;
      const panelToTween = isIntro ? this._introPanel : this._outroPanel;
      panelToTween.alpha = 1;
      gsap.fromTo(panelToTween.scale, { x: 0.2, y: 0.2 }, { x: 0.8, y: 0.8, duration: 0.8 });
    }

    floatIn(object, delay, duration, cb = undefined) {
      gsap.fromTo(
        object,
        {
          x: 0,
          y: 500,
        },
        {
          delay,
          duration,
          ease: "elastic.out(1.0, 0.4)",
          x: 0,
          y: 0,
          onStart: () => {
            this._fullPanel.visible = true;
          },
          onComplete: () => {
            if (cb) {
              cb();
            }
          },
        }
      );
    }

    fadeIn(object, alpha, duration, delay) {
      gsap.fromTo(
        object,
        {
          alpha: 0,
        },
        {
          delay: delay,
          duration: duration,
          alpha: alpha,
          onStart: () => {
            object.visible = true;
          },
        }
      );
    }

    bounceIn(object, delay, duration, scale) {
      gsap.fromTo(
        object.scale,
        {
          x: 0,
          y: 0,
        },
        {
          delay: delay,
          duration: duration ?? 1,
          ease: "Bounce.easeOut",
          x: scale ?? 1,
          y: scale ?? 1,
          onStart: () => {
            object.visible = true;
            object.alpha = 1;
          },
          onComplete: () => {
            this.setActive();
          },
        }
      );
    }

    setActive() {
      this._pressStartBox.interactive = true;
      this._pressStartBox.mousedown = this._pressStartBox.touchstart = this.closeDialog.bind(this);
    }

    showOutro(cashWon, callback) {
      musicManager.onFreeSpinsOutro();

      resourceManager.getContainer("gambleIntroContainer").visible = true;
      gameController.devilCharacter.idleLoop();

      gameController.canSlamStop = false;

      // gameController.fullScreenBubblesFront.startBubbles();
      // timerManager.addTimeout(500, function () {
      //   gameController.fullScreenBubblesFront.stopBubbles();
      // });
      // gameController.fullScreenBubblesBack.startBubbles();

      this.fadeIn(this._gambleBacker, 0.8, 1.0, 0.0);

      this._introActive = false;
      this._fullPanel.visible = true;
      this.setup();

      this._callback = callback;

      this._outroPanel.visible = true;
      this._introPanel.visible = false;

      this._cashWon.visible = true;

      this.scaleInPanel(false);

      let self = this;
      timerManager.addTimeout(1500, function () {
        self.setActive();
      });

      resourceManager.get("freeSpinsIntroOutroContainer:FreeSpinsIntroOutro:outroPanel:congratulationsText").visible = cashWon > 0;

      this._cashWon.setText(gdk.formatCurrency(cashWon));
    }

    closeDialog() {
      let reels = resourceManager.get("slotContainer:reelContainer");
      reels.alpha = 1.0;

      this._pressStartBox.visible = false;
      this._pressStartBox.alpha = 0;
      this._pressStartBox.interactive = false;
      this._pressStartBox.mousedown = this._pressStartBox.touchstart = undefined;

      musicManager.popupExit();

      if (this._introActive) {
        musicManager.onFreeSpinsStart();
        this.scaleOutPanel(true);
      } else {
        if (musicManager.fsOutroTimer != null) {
          timerManager.stop(musicManager.fsOutroTimer);
          musicManager.fsOutroTimer = null;
          musicManager.onFreeSpinsEnd();
        }
        this.scaleOutPanel(false);
      }
    }

    async scaleOutPanel(isIntro) {
      const panelToTween = isIntro ? this._introPanel : this._outroPanel;
      this.fadeOut(this._gambleBacker, 1.0);
      gsap.to(panelToTween.scale, { x: 0.2, y: 0.2, duration: 0.8 });
      await gsap.to(panelToTween, { alpha: 0, duration: 0.8 });
      this._callback();
    }

    clearOutro() {
      this.fadeOut(this._gambleBacker, 1.0);
      this.riseUp(this._fullPanel, 1.0);

      gameController.fullScreenBubblesFront.stopBubbles();
      gameController.fullScreenBubblesBack.stopBubbles();

      const self = this;
      timerManager.addTimeout(500, function () {
        self._callback();
      });
    }

    fadeOut(object, duration) {
      gsap.to(object, {
        duration: duration,
        alpha: 0,
        ease: "power1.in",
        onComplete: () => {
          object.visible = false;
          object.alpha = 1;
        },
      });
    }

    riseUp(object, duration, cb) {
      const originalPosition = {
        x: gsap.getProperty(object, "x"),
        y: gsap.getProperty(object, "y"),
      };

      gsap.to(object, {
        duration: duration,
        x: 0,
        y: -1000,
        ease: "power4.in",
        onComplete: () => {
          object.visible = false;
          gsap.set(object, { x: originalPosition.x, y: originalPosition.y });
          if (cb) {
            cb();
          }
        },
      });
    }
  }

  let freeSpinsIntroOutroCreator = function (json) {
    return new FreeSpinsIntroOutro();
  };

  let freeSpinsIntroOutroInitialiser = function (json, disclaimer) {
    disclaimer.initialise();
  };

  let freeSpinsIntroOutroFilesRequired = function () {
    return [];
  };

  resourceManager.registerObjectType(
    "FreeSpinsIntroOutro",
    freeSpinsIntroOutroCreator,
    freeSpinsIntroOutroInitialiser,
    freeSpinsIntroOutroFilesRequired
  );
})();
